export const version = "wordlists/5.5.0";
